<template>
	<van-popup v-model="visible" position="bottom" round class="audit-department-picker">
		<!-- 头部 -->
		<div class="audit-department-picker__header">
			<span class="audit-department-picker__title">选择科室</span>
			<!-- <van-icon name="cross" class="audit-department-picker__close" @click="visible = false" /> -->
		</div>

		<!-- 搜索 -->
		<div class="audit-department-picker__search">
			<van-search
				v-model="keyword"
				placeholder="搜索科室"
				shape="round"
				background="transparent"
				@input="onSearch"
			/>
		</div>

		<!-- 搜索模式 -->
		<div class="audit-department-picker__body" v-if="keyword">
			<div class="audit-department-picker__search-list">
				<div
					class="audit-department-picker__search-item"
					v-for="item in searchList"
					:key="item.id"
					:class="{ 'is-selected': isSelected(item) }"
					@click="selectSearch(item)"
				>
					<div class="audit-department-picker__search-icon">
						<van-icon name="label-o" />
					</div>
					<div class="audit-department-picker__search-main">
						<div class="audit-department-picker__search-name">{{ item.name }}</div>
						<div class="audit-department-picker__search-parents" v-if="getParents(item)">{{ getParents(item) }}</div>
					</div>
					<van-icon name="success" v-if="isSelected(item)" class="audit-department-picker__selected-icon" />
				</div>
				<van-empty v-if="!searchList.length && !loading" description="暂无数据" />
			</div>
		</div>

		<!-- 树模式 -->
		<div v-else class="audit-department-picker__body">
			<div class="audit-department-picker__cols">
				<!-- 左侧一级科室 -->
				<div class="audit-department-picker__level">
					<div
						class="audit-department-picker__level-item"
						v-for="item in tree"
						:key="item.id"
						:class="{ 'is-active': currentLevel1 && currentLevel1.id === item.id }"
						@click="selectLevel1(item)"
					>{{ item.name }}</div>
					<van-empty v-if="!tree.length && !loading" description="暂无数据" />
				</div>
				<!-- 右侧层级内容 -->
				<div class="audit-department-picker__detail">
					<div class="audit-department-picker__crumbs" v-if="crumbList.length">
						<span
							v-for="(crumb, i) in crumbList"
							:key="crumb.id"
							:class="{ 'is-current': i === crumbList.length - 1 }"
							@click="backTo(i)"
						>
							{{ crumb.name }}<span v-if="i < crumbList.length - 1" class="audit-department-picker__crumb-sep">/</span>
						</span>
					</div>
					<div class="audit-department-picker__grid">
						<div
							class="audit-department-picker__grid-item"
							v-for="item in currentChildren"
							:key="item.id"
							:class="{ 'is-selected': isSelected(item) }"
							@click="selectLevel(item)"
						>
							<span class="audit-department-picker__grid-name">{{ item.name }}</span>
							<van-icon name="arrow" v-if="hasChild(item)" class="audit-department-picker__grid-arrow" />
							<van-icon name="success" v-else-if="isSelected(item)" class="audit-department-picker__grid-check" />
						</div>
					</div>
					<van-empty v-if="!currentChildren.length && !loading" description="请选择左侧科室" />
				</div>
			</div>
		</div>

		<!-- 底部确认 -->
		<div class="audit-department-picker__footer">
			<div class="audit-department-picker__selected" :class="{ 'is-empty': !selectedDept }">
				<template v-if="selectedDept">已选：<span class="audit-department-picker__selected-name">{{ selectedDept.name }}</span></template>
				<template v-else>请选择科室</template>
			</div>
			<van-button type="primary" block :disabled="!selectedDept" @click="handleConfirm">确定</van-button>
		</div>
	</van-popup>
</template>

<script>
// 科室选择弹层（对应小程序 base-department，UI 为左侧一级类目 + 右侧层级下钻）
export default {
	name: 'AuditDepartmentPicker',
	props: {
		value: {
			type: Boolean,
			default: false,
		},
	},
	data: () => ({
		keyword: '',
		searchTimer: null,
		searchList: [],
		loading: false,
		tree: [],
		// 当前一级
		currentLevel1: null,
		// 层级路径（一级 -> ... -> 当前级）
		crumbList: [],
		// 当前级子列表
		currentChildren: [],
		// 选中的叶子科室
		selectedDept: null,
	}),
	computed: {
		visible: {
			get() {
				return this.value
			},
			set(val) {
				this.$emit('input', val)
			},
		},
	},
	watch: {
		visible(val) {
			if (val) {
				this.reset()
				this.getTree()
			}
		},
	},
	methods: {
		reset() {
			this.keyword = ''
			this.searchList = []
			this.selectedDept = null
			this.currentLevel1 = null
			this.crumbList = []
			this.currentChildren = []
		},
		getTree() {
			if (this.tree.length) {
				this.initDefaultLevel()
				return
			}
			this.loading = true
			this.$api.cpnt
				.departPage()
				.then((res) => {
					this.loading = false
					if (!res.code) {
						this.tree = res.data || []
						this.initDefaultLevel()
					}
				})
				.catch(() => {
					this.loading = false
				})
		},
		// 默认选中第一个一级科室
		initDefaultLevel() {
			if (this.tree.length) {
				this.selectLevel1(this.tree[0])
			}
		},
		hasChild(item) {
			return item.respBodyList && item.respBodyList.length
		},
		// 选择左侧一级
		selectLevel1(item) {
			this.currentLevel1 = item
			this.crumbList = [item]
			this.currentChildren = item.respBodyList || []
			this.selectedDept = null
		},
		// 选择右侧当前级子项
		selectLevel(item) {
			if (this.hasChild(item)) {
				// 有子级：下钻
				this.crumbList.push(item)
				this.currentChildren = item.respBodyList
			} else {
				// 叶子：选中
				this.selectedDept = item
			}
		},
		// 面包屑回退
		backTo(index) {
			this.crumbList = this.crumbList.slice(0, index + 1)
			this.currentChildren = this.crumbList[index].respBodyList || []
		},
		isSelected(item) {
			return this.selectedDept && this.selectedDept.id === item.id
		},
		onSearch() {
			if (this.searchTimer) clearTimeout(this.searchTimer)
			this.searchTimer = setTimeout(() => this.search(), 500)
		},
		search() {
			if (!this.keyword) {
				this.searchList = []
				return
			}
			this.loading = true
			this.$api.cpnt
				.departSearchList(this.keyword)
				.then((res) => {
					this.loading = false
					this.searchList = res.code ? [] : res.data || []
				})
				.catch(() => {
					this.loading = false
				})
		},
		getParents(item) {
			return (item.parentList || []).map((p) => p.name).join(' / ')
		},
		selectSearch(item) {
			this.selectedDept = item
		},
		handleConfirm() {
			if (!this.selectedDept) return
			this.visible = false
			this.$emit('confirm', this.selectedDept)
		},
	},
}
</script>

<style lang="less" scoped>
.audit-department-picker {
	display: flex;
	flex-direction: column;
	height: 75vh;

	&__header {
		position: relative;
		height: 48px;
		line-height: 48px;
		text-align: center;
		font-size: 16px;
		font-weight: 500;
		color: #1f2329;
		flex-shrink: 0;
	}

	&__close {
		position: absolute;
		top: 0;
		right: 16px;
		font-size: 18px;
		color: #8f959e;
	}

	&__search {
		flex-shrink: 0;

		::v-deep .van-search__content {
			background-color: #f5f6f7;
		}
	}

	&__body {
		flex: 1;
		overflow: hidden;
		display: flex;
		flex-direction: column;
	}

	// 左侧一级 + 右侧详情
	&__cols {
		flex: 1;
		display: flex;
		overflow: hidden;
	}

	&__level {
		width: 96px;
		height: 100%;
		overflow-y: auto;
		background-color: #f7f8fa;
		flex-shrink: 0;

		&-item {
			position: relative;
			padding: 14px 10px;
			font-size: 13px;
			line-height: 18px;
			color: #646a73;
			word-break: break-all;

			&.is-active {
				color: var(--color-primary);
				font-weight: 500;
				background-color: #fff;

				&::before {
					content: '';
					position: absolute;
					left: 0;
					top: 50%;
					transform: translateY(-50%);
					width: 3px;
					height: 16px;
					border-radius: 2px;
					background-color: var(--color-primary);
				}
			}
		}
	}

	&__detail {
		flex: 1;
		height: 100%;
		overflow-y: auto;
		background-color: #fff;
	}

	&__crumbs {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		padding: 12px 14px 4px;
		font-size: 12px;
		color: #8f959e;

		span {
			cursor: pointer;

			&.is-current {
				color: #1f2329;
				font-weight: 500;
			}
		}

		&-sep {
			margin: 0 4px;
			color: #c8c9cc;
		}
	}

	&__grid {
		display: flex;
		flex-wrap: wrap;
		padding: 8px 12px 12px;

		&-item {
			position: relative;
			display: flex;
			align-items: center;
			width: calc(50% - 8px);
			margin: 6px 4px;
			padding: 10px 8px;
			box-sizing: border-box;
			border-radius: 8px;
			background-color: #f5f6f7;
			font-size: 13px;
			color: #1f2329;

			&.is-selected {
				color: var(--color-primary);
				background-color: var(--color-primary-light);
				font-weight: 500;
			}
		}

		&-name {
			flex: 1;
			min-width: 0;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		&-arrow,
		&-check {
			margin-left: 2px;
			font-size: 12px;
			color: #c8c9cc;
			flex-shrink: 0;
		}

		&-check {
			color: var(--color-primary);
		}
	}

	// 搜索模式
	&__search-list {
		flex: 1;
		overflow-y: auto;
		padding: 4px 16px;
	}

	&__search-item {
		display: flex;
		align-items: center;
		padding: 13px 4px;
		border-bottom: 1px solid #f5f6f7;

		&.is-selected {
			.search-name {
				color: var(--color-primary);
				font-weight: 500;
			}
		}
	}

	&__search-icon {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 34px;
		height: 34px;
		margin-right: 12px;
		border-radius: 8px;
		background-color: var(--color-primary-light);
		flex-shrink: 0;

		.van-icon {
			font-size: 18px;
			color: var(--color-primary);
		}
	}

	&__search-main {
		flex: 1;
		min-width: 0;
	}

	&__search-name {
		font-size: 14px;
		color: #1f2329;
		word-break: break-all;
	}

	&__search-parents {
		margin-top: 2px;
		font-size: 12px;
		color: #8f959e;
		word-break: break-all;
	}

	&__selected-icon {
		margin-left: 8px;
		font-size: 16px;
		color: var(--color-primary);
	}

	// 底部确认
	&__footer {
		flex-shrink: 0;
		padding: 10px 16px calc(16px + constant(safe-area-inset-bottom));
		padding-bottom: calc(16px + env(safe-area-inset-bottom));
		border-top: 1px solid #f5f6f7;
		background-color: #fff;
	}

	&__selected {
		margin-bottom: 10px;
		font-size: 13px;
		text-align: center;
		color: #1f2329;

		&.is-empty {
			color: #8f959e;
		}
	}

	&__selected-name {
		color: var(--color-primary);
		font-weight: 500;
	}
}
</style>
